class CartRecommendations {
  constructor() {
    this.loading = false;
    this.updateTimeout = null;

    this.init();
  }

  init() {
    this.load();
    this.observeCartChanges();

    document.addEventListener(
      'click',
      this.handleAddToCart.bind(this)
    );
  }

  observeCartChanges() {
    const observer = new MutationObserver(() => {
      clearTimeout(this.updateTimeout);

      this.updateTimeout = setTimeout(() => {
        this.load();
      }, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  async getCart() {
    const response = await fetch('/cart.js');

    if (!response.ok) {
      throw new Error('Could not get cart');
    }

    return response.json();
  }

  
  
  
  initCarousel(container) {
    const viewport = container.querySelector(
        '.cart-recommendations-embla'
    );

    if (!viewport) return;

    if (viewport.embla) {
        viewport.embla.destroy();
    }

    const embla = EmblaCarousel(
        viewport,
        {
        align: 'start',
        slidesToScroll: 1,
        dragFree: true,
        containScroll: 'trimSnaps'
        }
    );

    viewport.embla = embla;

    const prevButton = container.querySelector(
        '.cart-recommendations-prev'
    );

    const nextButton = container.querySelector(
        '.cart-recommendations-next'
    );

    if (prevButton) {
        prevButton.addEventListener(
        'click',
        () => embla.scrollPrev()
        );
    }

    if (nextButton) {
        nextButton.addEventListener(
        'click',
        () => embla.scrollNext()
        );
    }

    const updateButtons = () => {
        if (prevButton) {
        prevButton.disabled = !embla.canScrollPrev();
        }

        if (nextButton) {
        nextButton.disabled = !embla.canScrollNext();
        }
    };

    embla.on('select', updateButtons);
    embla.on('reInit', updateButtons);

    updateButtons();
    }




  async load() {
    const container = document.querySelector(
      '[data-cart-recommendations]'
    );

    if (!container || this.loading) {
      return;
    }

    this.loading = true;

    try {
      const cart = await this.getCart();

      if (!cart.items || cart.items.length === 0) {
        container.innerHTML = '';
        return;
      }

      const productId = cart.items[0].product_id;

      const cartKey = cart.items
        .map(item => item.product_id)
        .join('-');

      if (
        container.dataset.loadedCartKey === cartKey
      ) {
        return;
      }

      const url = new URL(
        '/recommendations/products',
        window.location.origin
      );

      url.searchParams.set(
        'section_id',
        'cart-recommendations'
      );

      url.searchParams.set(
        'product_id',
        productId
      );

      url.searchParams.set(
        'limit',
        '8'
      );

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(
          `Error loading recommendations: ${response.status}`
        );
      }

      const html = await response.text();

      const currentContainer = document.querySelector(
        '[data-cart-recommendations]'
      );

      if (!currentContainer) {
        return;
      }

      const parser = new DOMParser();

      const parsedDocument = parser.parseFromString(
        html,
        'text/html'
      );

      const section = parsedDocument.querySelector(
        '#shopify-section-cart-recommendations'
      );

      if (section) {
        currentContainer.innerHTML =
          section.innerHTML;

        currentContainer.dataset.loadedCartKey =
          cartKey;

        currentContainer.dataset.productId =
          productId;

        this.initCarousel(currentContainer);

      } else {
        currentContainer.innerHTML = '';
      }

    } catch (error) {
      console.error(
        '[Cart Recommendations]',
        error
      );

    } finally {
      this.loading = false;
    }
  }

  async handleAddToCart(event) {
    const button = event.target.closest(
      '.cart-recommendation-add'
    );

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled) {
      return;
    }

    const variantId = button.dataset.variantId;

    if (!variantId) {
      return;
    }

    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Agregando...';

    try {
      const response = await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },

          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        }
      );

      if (!response.ok) {
        throw new Error(
          'Error adding product'
        );
      }

      if (
        typeof window.updateMiniCart === 'function'
      ) {
        await window.updateMiniCart(true);
      }

      setTimeout(() => {
        this.load();
      }, 300);

    } catch (error) {
      console.error(
        '[Cart Recommendations]',
        error
      );

      button.disabled = false;
      button.textContent = originalText;
    }
  }
}

window.cartRecommendations =
  new CartRecommendations();